import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme=>({
    colorComponente:{
        backgroundColor: 'white',
        alignItems: "center",
        borderRadius: 20,
        flexFlow: "row-wrap",
        '@media (max-width:415px)':{ //mobile
            marginBottom: 10,
        },
        '@media (max-width:320px)':{ //mobile
            marginBottom: 10,
        }                
    },

    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },        
    },

    rootList: {
        flexGrow: 1,
    },
    
    rootLista: {
        width: '100%',
        maxWidth: '100%',
    }, 

    centrarBoton:{
        textAlign: 'center',
    },
    
    lineaDegradadaBottom:{
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background: `linear-gradient(344deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)`,
    },
}))